<template>
  <v-tabs
    v-if="currentLocation === null"
    v-model="currentLocationIndex"
    vertical
  >
    <mv-edit-frame
      v-if="editMachine != null"
      :editMachine="editMachine"
      :editCreate="editCreate"
      v-on:closeDialog="editMachine = null"
    ></mv-edit-frame>
    <v-tab
      v-for="(machines, location) in locations"
      :key="location"
      style="text-align: left"

    >
      <v-icon>
        mdi-notebook-outline
      </v-icon>
      <v-badge
        v-if="location in getActiveLocation"
        dot
        color="success"
      >
        {{ location }}
      </v-badge>
      <div
        v-else
      >
        {{ location }}
      </div>
    </v-tab>
    <v-tab-item
      v-for="(machines, location) in locations"
      :key="location"
      class="mb-4"
    >
      <v-card>
        <v-card-text>
          <v-container
            fluid
          >
            <v-row>
              <v-spacer></v-spacer>
              <v-col
                cols="12"
                style="float: right"
              >
                <v-sheet
                  class="pa-2"
                  outlined

                >
                  <v-btn
                    class="mr-2"
                    text
                    :color="kategory_update_color(machines)"
                    @click="start_update_kategory(location)"
                  >
                    <v-icon left>
                      mdi-arrow-up-bold-outline
                    </v-icon>
                    Alle updaten
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="load_wol_all"
                    :disabled="load_wol_all"
                    @click="wol_kategory(location)"
                  >
                    <v-icon
                      left
                    >
                      mdi-power
                    </v-icon>
                    Alle starten
                    <template v-slot:loader>
                        <span class="custom-loader">
                          <v-icon light>mdi-cached</v-icon>
                        </span>
                    </template>
                  </v-btn>
                  <v-btn
                    style="float: right"
                    color="primary"
                    @click="editCreate = true; editMachine = { id: '', displayName: '', description: '', tags: '', kategory: '', proxy_link: '', online: -1, host: '', mac: '', port: '', password: '', vnc_ip: '', vnc_port: '' }"
                  >
                    Neu anlegen
                  </v-btn>
                </v-sheet>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-for="(machine, index) in machines"
                :key="index"

                cols="12"
                xs="12"
                sm="6"
                md="4"
                lg="3"
                xl="2"
              >
                <v-card
                  class=""
                  elevation="4"
                  @dblclick="openVNC(index + 1, location)"
                >
                  <v-card-title>
                    {{ machine.displayName }}
                    <v-spacer></v-spacer>
                    <v-tooltip
                      v-if="update_possible(machine)"
                      bottom
                      max-width="440"
                      open-delay="300"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <!-- Die Huelle traegt den Hinweis, nicht der Knopf: waehrend eines
                             Laufs ist der Knopf deaktiviert und meldet keine Mausereignisse
                             mehr - genau dann will man den Zustand aber sehen. -->
                        <span
                          class="d-inline-block"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-btn
                            icon
                            class="mr-1"
                            :color="update_color(machine)"
                            :disabled="update_busy(machine)"
                            @click.stop="start_update(machine)"
                            @dblclick.stop="start_update(machine)"
                          >
                            <v-badge
                              :content="String(update_state(machine).pending)"
                              :value="update_state(machine).pending > 0"
                              color="purple"
                              overlap
                            >
                              <v-icon>
                                mdi-arrow-up-bold-outline
                              </v-icon>
                            </v-badge>
                          </v-btn>
                        </span>
                      </template>
                      <div class="subtitle-2">Updates – {{ machine.displayName }}</div>
                      <mv-update-status :machine="machine"></mv-update-status>
                      <div
                        v-if="!update_busy(machine)"
                        class="caption mt-2"
                      >
                        Klick startet den Update-Modus.
                      </div>
                    </v-tooltip>
                    <!-- Wecken laeuft ueber den Satelliten aus proxy_link und braucht die
                         MAC. Fehlt eines davon, bleibt nur der Statuspunkt darunter: ein
                         Knopf, der den Rechner nicht einschalten kann, ihn aber auf der
                         Kachel auf "aus" springen laesst, sieht wie ein Ausschalter aus. -->
                    <v-btn
                      v-if="machine.mac && machine.proxy_link"
                      icon
                      large
                      :color="(machine.online == -1) ? 'error' : (machine.online == 0) ? 'success' : 'warning'"
                      @click.stop="wol(machine)"
                      @dblclick.stop="wol(machine)"
                    >
                      <v-icon
                        large
                      >
                        mdi-power
                      </v-icon>
                    </v-btn>
                    <v-avatar
                      v-else
                      :color="(machine.online == -1) ? 'error' : (machine.online == 0) ? 'success' : 'warning'"
                      size="24"
                    >

                    </v-avatar>
                  </v-card-title>
                  <v-card-text>
                    <v-img
                      src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                      gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
                      contain
                    ></v-img>
                  </v-card-text>
                  <v-card-text
                    v-if="update_phase_text(machine)"
                    class="py-1"
                  >
                    <div class="caption">{{ update_phase_text(machine) }}</div>
                    <v-progress-linear
                      indeterminate
                      color="warning"
                      height="3"
                    ></v-progress-linear>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-chip
                      v-for="(tag, index_t) in machine.tags.split(';')"
                      :key="index_t"
                      class="mr-1"
                      small
                    >
                      {{ tag }}
                    </v-chip>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      @click="editCreate = false; editMachine = { ...machine}"
                    >
                      <v-icon
                      >
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn
                      color="success"
                      icon
                      :disabled="!is_vnc_enabled"
                      @click="openVNC(index + 1, location)"
                    >
                      <v-icon
                      >
                        mdi-play
                      </v-icon>
                    </v-btn>

                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

    </v-tab-item>
  </v-tabs>
  <v-tabs
    v-else
    v-model="currentMachineIndex"
    vertical
  >
    <v-tab
      @click="currentMachineIndex = -1; currentLocation = null"
      eager
    >
      <v-icon
        class="mr-1"
      >
        mdi-close
      </v-icon>
      Zurück
    </v-tab>
    <v-tab
      v-for="(machine, index) in locations[currentLocation]"
      :key="index"
    >
      <v-badge
        v-if="machine.online == 0"
        dot
        color="success"
      >
        {{ machine.displayName }}
      </v-badge>
      <div
        v-else
      >
        {{ machine.displayName }}
      </div>
    </v-tab>
    <v-tab-item></v-tab-item>
    <v-tab-item
      v-for="(machine, index) in locations[currentLocation]"
      :key="index"
    >
      <novnc-window
        v-if="currentMachineIndex === index+1"
        :host="machine.vnc_ip"
        :port="machine.vnc_port"
        :password="machine.password"
      ></novnc-window>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import NovncWindow from "../components/MachineViewer/novnc-window";
import MvEditFrame from "../components/MachineViewer/mv-edit-frame";
import MvUpdateStatus from "../components/MachineViewer/mv-update-status";
export default {
  name: "VNCView",
  components: { MvEditFrame, MvUpdateStatus, NovncWindow },
  data: () => ({
    is_vnc_enabled: true,
    load_wol_all: null,
    currentLocationIndex: 0,
    currentLocation: null,
    currentMachineIndex: -1,
    editMachine: null,
    editCreate: false
  }),
  methods: {
    wol(machine){
      this.$store.dispatch("update", { payload_type: 'POST', context: "/vnc/wol/mac/" + machine.id})
    },
    wol_kategory(kategory){
      this.load_wol_all = true
      setTimeout(() => (this.load_wol_all = false), 5000)
      this.$store.dispatch("update", { payload_type: 'POST', context: "/vnc/wol/group/" + kategory})
    },
    update_possible(machine){
      // Updatebar ist nur, wer sich auch wecken laesst: das Wecken laeuft ueber
      // den Satelliten aus proxy_link und braucht die MAC, der Zugriff danach den
      // Host. Fehlt eines davon, sucht der Server fuer diesen Rechner auch nicht
      // nach Updates - ein Knopf mit dauerhaft leerem Zaehler waere nur Rauschen.
      return Boolean(machine.host && machine.mac && machine.proxy_link)
    },
    update_state(machine){
      // Aeltere Antworten kennen den Schluessel noch nicht - die Kachel darf davon
      // nicht abhaengen.
      return machine.update || { status: 'idle', phase: null, scan_only: false, auto: false, cycle: 0, max_cycles: 0, pending: null, installed: [], message: '' }
    },
    update_busy(machine){
      let state = this.update_state(machine)
      // Die automatische Suche laeuft im Hintergrund und sperrt den Knopf nicht.
      // Wer in dem kurzen Fenster trotzdem startet, bekommt die Meldung des
      // Servers - besser als ein Knopf, der ohne erkennbaren Grund tot ist.
      if(state.auto) return false
      return state.status === 'queued' || state.status === 'running'
    },
    update_color(machine){
      let state = this.update_state(machine)
      // Eine automatische Suche bleibt unsichtbar - auch wenn sie scheitert.
      // Sonst faerbte ein Rechner mit dichter Firewall bei jedem Seitenaufruf
      // still seine Kachel rot, ohne dass jemand etwas ausgeloest haette.
      if(state.auto) return (state.pending > 0) ? 'purple' : 'grey'
      if(state.status === 'queued' || state.status === 'running') return 'warning'
      if(state.status === 'error' || state.status === 'unreachable') return 'error'
      // Lila signalisiert bekannte offene Updates, grau heisst "nichts zu tun" -
      // auch nach einem erledigten Lauf. Gruen bliebe dauerhaft stehen und zoege
      // Aufmerksamkeit auf eine Kachel, an der gerade nichts mehr zu tun ist;
      // eingefaerbt wird nur, was jemanden angeht: offene Updates und Fehler.
      if(state.pending > 0) return 'purple'
      return 'grey'
    },
    kategory_update_color(machines){
      // Lila nur, wenn in dieser Kategorie wirklich etwas offen ist - ein
      // Sammelknopf, der immer eingefaerbt ist, sagt nichts aus. Solange noch
      // niemand gesucht hat, ist pending null und der Knopf bleibt unauffaellig.
      let offen = machines.some(machine => this.update_state(machine).pending > 0)
      return offen ? 'purple' : ''
    },
    update_phase_text(machine){
      let state = this.update_state(machine)
      if(state.auto) return ''
      if(state.status === 'queued') return 'Warteschlange'
      if(state.status !== 'running') return ''
      let phasen = { wecken: 'Rechner wecken', warten: 'Warten auf den Rechner', suchen: 'Updates suchen', installieren: 'Updates installieren', neustart: 'Neustart', herunterfahren: 'Herunterfahren' }
      let text = phasen[state.phase] || 'Läuft'
      if(!state.scan_only && state.cycle > 0){
        // "2/3" liess offen, was der Bruch zaehlt - ausgeschrieben nicht.
        text += ' – Durchlauf ' + state.cycle + ' von ' + state.max_cycles
      }
      return text
    },
    start_update(machine){
      this.$store.state.general.dialogs.push({
        title: 'Update-Modus starten',
        text: 'Der Rechner ' + machine.displayName + ' wird geweckt, installiert alle offenen Windows-Updates, startet dabei bei Bedarf neu und wird danach heruntergefahren. Eine angemeldete Sitzung geht dabei verloren.',
        btn_1_title: 'Abbrechen',
        btn_2_title: 'Starten',
        btn_2_update: { payload_type: 'POST', context: '/vnc/update/' + machine.id },
        btn_2_color: 'warning',
        show: true
      })
    },
    start_update_kategory(kategory){
      this.$store.state.general.dialogs.push({
        title: 'Alle updaten',
        text: 'Alle Rechner der Kategorie ' + kategory + ' werden geweckt, installieren ihre Windows-Updates und werden danach heruntergefahren. Angemeldete Sitzungen gehen dabei verloren.',
        btn_1_title: 'Abbrechen',
        btn_2_title: 'Alle updaten',
        btn_2_update: { payload_type: 'POST', context: '/vnc/update/group/' + kategory },
        btn_2_color: 'warning',
        show: true
      })
    },
    closeEdit(){
      this.editMachine = null
    },
    openVNC(index, location){
      if(this.is_vnc_enabled){
        this.currentMachineIndex = index;
        this.currentLocation = location
      }

    }
  },
  computed: {
    locations () {
      let locations = {}
      let store_locations = this.$store.state.machine_viewer.locations
      if (store_locations === null) {
        return []
      }
      let searchQuery = this.$store.state.general.global_search.toLowerCase()
      store_locations = store_locations.filter(ma => ma.displayName.toLowerCase().includes(searchQuery) || ma.tags.toLowerCase().includes(searchQuery))
      store_locations = store_locations.sort((a, b) => a.displayName.localeCompare(b.displayName, 'de', { numeric: true, sensitivity: 'base' }))
      for(let index in store_locations){
        let location = store_locations[index]
        if(location["kategory"] in locations){
          locations[location["kategory"]].push(location)
        }
        else {
          locations[location["kategory"]] = [location]
        }
      }
      return locations
    },
    getActiveLocation(){
      let activeLocations = {}
      for(let index in this.$store.state.machine_viewer.locations){
        if(this.$store.state.machine_viewer.locations[index].online == 0){
          activeLocations[this.$store.state.machine_viewer.locations[index].kategory] = true
        }
      }
      return activeLocations
    }
  },
  mounted() {
    if (this.$store.state.machine_viewer.locations === null) {
      this.$store.dispatch("update", { "context": "/vncs"})
    }
  }
};
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
